export { FunctionTestWidget } from './function-test.widget';
export type {
  FunctionTestWidgetConfig,
  FunctionTestParams,
  FunctionTestCurve,
  ExpressionCurve,
  ParametricExpressionCurve,
  DataCurve,
} from './function-test.model';
export { FUNCTION_TEST_PRESETS } from './presets';
export * from './presets';
